var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.430176 0.480469H32.0587V19.7662H0.430176V0.480469ZM16.2445 5.3019C17.6425 5.3019 18.9833 5.80987 19.9719 6.71406C20.9605 7.61825 21.5159 8.8446 21.5159 10.1233C21.5159 11.402 20.9605 12.6284 19.9719 13.5326C18.9833 14.4368 17.6425 14.9448 16.2445 14.9448C14.8464 14.9448 13.5056 14.4368 12.517 13.5326C11.5284 12.6284 10.973 11.402 10.973 10.1233C10.973 8.8446 11.5284 7.61825 12.517 6.71406C13.5056 5.80987 14.8464 5.3019 16.2445 5.3019ZM7.45875 3.69475C7.45875 4.54724 7.08849 5.3648 6.42944 5.9676C5.77038 6.57039 4.87651 6.90904 3.94446 6.90904V13.3376C4.87651 13.3376 5.77038 13.6763 6.42944 14.2791C7.08849 14.8819 7.45875 15.6994 7.45875 16.5519H25.0302C25.0302 15.6994 25.4004 14.8819 26.0595 14.2791C26.7185 13.6763 27.6124 13.3376 28.5445 13.3376V6.90904C27.6124 6.90904 26.7185 6.57039 26.0595 5.9676C25.4004 5.3648 25.0302 4.54724 25.0302 3.69475H7.45875Z",
    fill: "#0FB574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cashIcon.79ad48379f146a024768974a1568b8c3.svg";
export { ForwardRef as ReactComponent };